import { AdminDepartment, CurrentDepartmentResponse, Department } from '../models/Department';
import { deleteRequest, getRequest, host, patchRequest, postRequest, putRequest } from './apiService';

const departmentApi = `${host}/api/departments`;
const userDepartmentsApi = `${host}/api/UserDepartments`;

export async function fetchDepartments(): Promise<Department[]> {
	return getRequest<Department[]>(departmentApi);
}

export async function fetchAdminDepartments(): Promise<AdminDepartment[]> {
	return getRequest<AdminDepartment[]>(`${departmentApi}/admin`);
}

export async function fetchCurrentDepartment(hostName: string): Promise<CurrentDepartmentResponse> {
	const params = new URLSearchParams({ hostName });
	return getRequest<CurrentDepartmentResponse>(`${departmentApi}/current?${params.toString()}`);
}

export async function updateUserDepartments(userId: string, departmentIds: number[]): Promise<void> {
	await putRequest<void>(`${userDepartmentsApi}/users/${userId}`, { departmentIds });
}

export async function addDepartment(department: AdminDepartment): Promise<AdminDepartment | undefined> {
	const { id, domains, ...request } = department;
	return postRequest<AdminDepartment | undefined>(departmentApi, request);
}

export async function updateDepartment(department: AdminDepartment): Promise<AdminDepartment> {
	const { domains, ...request } = department;
	return patchRequest<AdminDepartment>(`${departmentApi}/${department.id}`, request);
}

export async function deleteDepartment(id: number): Promise<void> {
	return deleteRequest(`${departmentApi}/${id}`);
}
